<template>
    <div class="flex space-x-1 justify-center rounded-lg bg-gray-200 p-0.5" role="tablist" aria-orientation="horizontal">
        <button
            v-for="option in options"
            :key="option.value"
            @click="localValue = option.value"
            class="flex items-center rounded-md py-2 pl-2 pr-2 lg:pr-3 "
            :class="{
                'bg-white shadow text-slate-900': isSelected(option),
                'text-slate-600': !isSelected(option),
            }"
             role="tab" type="button">
            <span class="lg:ml-2 text-slate-900 font-medium text-xs px-1">
                {{ option.label }}
            </span>
        </button>
    </div>
</template>

<script>
export default {
    name: "SwitchButton",
    computed: {
        localValue: {
            get() {
                return this.value
            },
            set(localValue) {
                this.$emit('input', localValue)
            }
        },
    },
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: String | Number,
            default: null
        },
        name: {
            type: String,
            default: null
        },
    },
    methods: {
        isSelected(option) {
            return option.value === this.localValue
        },
        select(option) {
            this.localValue = option.value
        }
    },
    created() {

    }
}
</script>

<style scoped>

</style>
